module.exports = __webpack_public_path__ + "static/media/hab4-0.78a2e079.jpg";